export const TOS_STORAGE_KEY = 'user:tosConsent';
export const EULA_STORAGE_KEY = 'user:eulaConsent';
